<ngx-heka-heka-navigation-container appTitle="{{'APPS.LEVEL_2.TITLE'|translate}}"
                                    appImageLink="{{'assets/images/heka-logo-symbols/hplus.svg'}}"
                                    startPage="/pages"
                                    collapseText="{{'MENU.COLLAPSE'|translate}}"
                                    [accountMenu]="accountMenu"
                                    [helpLink]="env.links.help"
                                    [loading]="(loadingService.getLoading().asObservable() |async)||false"
                                    (onDomainChange)="domainHandlerService.switchDomainAndReload($event.domainId)">
<ng-content/>
</ngx-heka-heka-navigation-container>
